const rooms = {
  hu: {
    Universal: "Universal",
    Konyha: "Konyha",
    Hálószoba: "Hálószoba",
    Nappali: "Nappali",
    Gardrób: "Gardrób",
    Iroda: "Iroda",
    Szoba: "Szoba"
  },
  ro: {
    Universal: "Universal",
    Konyha: "Bucătărie",
    Hálószoba: "Dormitor",
    Nappali: "Living",
    Gardrób: "Dressing",
    Iroda: "Birou",
    Szoba: "Cameră"
  },
  en: {
    Universal: "Universal",
    Konyha: "Kitchen",
    Hálószoba: "Bedroom",
    Nappali: "Living room",
    Gardrób: "Wardrobe",
    Iroda: "Office",
    Szoba: "Room"
  }
};

export default rooms;
